import React from "react";
import { Link } from "react-router-dom";
import google from "../../assets/google.svg"
import apple from "../../assets/apple.svg"
import localization from '../../Localization/Localization.json'
import "./Footer.scss";
import { connect } from "react-redux";
function Footer({currentLang}) {
  return (
    <div className="footer-wrapper">
      <div className="container">
        <div className="footer-content">
          <div className="links-wrapper">
            <div className="links-group">
              <h4>{localization.Quicklinks[currentLang]}</h4> 
              <ul>
                <li>
                  <Link to="/">{localization.home[currentLang]}</Link>
                </li>
                <li>
                  <Link to="/">{localization.Aboutus[currentLang]}</Link>
                </li>
                <li>
                  <Link to="/">{localization.TermsConditions[currentLang]}</Link>
                </li>
              </ul>
            </div>
            <div className="links-group">
              <h4>{localization.Contactus[currentLang]}</h4>
              <ul>
                <li>
                  <a href="tel:+971 4 865 0569">+971 4 865 0569</a>
                </li>
                <li>
                  <a 
                  href="mailto:Support@orderforme.com">
                    Support@orderforme.com
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="http://maps.google.com/?q=Dubai Investment Park - 1 Mina Jebel Ali - Dubai"
                  >
                    Dubai Investment Park - 1 Mina Jebel Ali - Dubai
                  </a>
                </li>
              </ul>
            </div>
            <div className="links-group"> 
              <h4>{localization.Downloadapp[currentLang]}</h4>
              <ul>
                <li>
                  <Link to="/">
                    <img src={apple} alt="apple" /> 
                  </Link>
                </li>
                <li>
                  <Link to="/">
                    <img src={google} alt="google" />
                  </Link>
                </li>
                </ul>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
}) 

export default connect(mapStateToProps)(Footer);  
